import { useCallback, useEffect, useState } from "react";
import { GitMerge, Check, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "./ui/button";
import { api, errMsg } from "../lib/api";
import { fmtDate, fmtEUR } from "../lib/format";

const Item = ({ it, onResolve }) => {
  const [target, setTarget] = useState(it.candidates[0]?.id || "");
  const t = it.transaction;
  return (
    <li className="grid gap-2 border-b border-amber-100 py-3 last:border-0 md:grid-cols-[1fr_auto]" data-testid={`merge-review-item-${t.id}`}>
      <div className="text-sm">
        <span className="font-num">{fmtDate(t.value_date)} · {fmtEUR(t.amount)}</span> · {t.merchant}
        {(t.status !== "offen" || t.receipt_count > 0) && <span className="ml-2 text-xs text-slate-500">({t.receipt_count} Beleg(e), Status {t.status})</span>}
      </div>
      <div className="flex flex-wrap gap-2">
        {it.candidates.length > 0 && (
          <select value={target} onChange={(e) => setTarget(e.target.value)} className="h-9 max-w-64 rounded-md border border-input bg-white px-2 text-xs" data-testid={`merge-target-${t.id}`}>
            {it.candidates.map((c) => <option key={c.id} value={c.id}>Nr. {c.position} · {fmtDate(c.value_date)} · {fmtEUR(c.amount)} · {c.merchant}</option>)}
          </select>
        )}
        {it.candidates.length > 0 && <Button size="sm" onClick={() => onResolve(t.id, "merge", target)} className="gap-1 bg-slate-900" data-testid={`merge-btn-${t.id}`}><GitMerge className="h-3.5 w-3.5" />Zusammenführen</Button>}
        <Button size="sm" variant="outline" onClick={() => onResolve(t.id, "keep")} className="gap-1" data-testid={`merge-keep-btn-${t.id}`}><Check className="h-3.5 w-3.5" />Behalten</Button>
        <Button size="sm" variant="ghost" onClick={() => onResolve(t.id, "delete")} className="gap-1 text-red-700" data-testid={`merge-delete-btn-${t.id}`}><Trash2 className="h-3.5 w-3.5" />Duplikat entfernen</Button>
      </div>
    </li>
  );
};

export const MergeReview = ({ st, onChanged }) => {
  const [items, setItems] = useState([]);
  const load = useCallback(() => api.bankReview(st.id).then((r) => setItems(r.items)).catch(() => setItems([])), [st.id]);
  useEffect(() => { load(); }, [load, st.updated_at]);
  if (!items.length) return null;
  const resolve = async (tid, action, target_id) => {
    try { const r = await api.bankResolve(st.id, { transaction_id: tid, action, target_id }); toast.success(r.message); setItems(r.items); onChanged(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="rounded-xl border border-amber-300 bg-amber-50 p-4" data-testid="merge-review">
      <div className="font-semibold text-slate-900">Abgleich mit Bankverbindung: {items.length} Umsätze ohne Gegenstück im PDF</div>
      <p className="text-sm text-slate-600">Diese Bankumsätze liegen im Zeitraum des Auszugs, wurden aber nicht automatisch zugeordnet. Nichts wird ohne deine Entscheidung gelöscht.</p>
      <ul className="mt-2">{items.map((it) => <Item key={it.transaction.id} it={it} onResolve={resolve} />)}</ul>
    </div>
  );
};
